// Utilities
import isEmpty from './isEmpty'
import Logger from './loggerUtil'

class CreditCardUtil {
  static formatCards (cards) {
    const newCards = []
    for (let i = 0; i < cards.length; i++) {
      const newCard = CreditCardUtil.formatCard(cards[i])

      if (newCard) {
        newCards.push(newCard)
      }
    }

    return newCards
  }

  static formatCard (cardObj) {
    const tempMonth = `0${cardObj.expirationMonth.toString()}`
    cardObj.expirationYear %= 100
    cardObj.expirationMonth = tempMonth.slice(-2)
    cardObj.cardNumber = `•••• •••• •••• ${cardObj.cardNumber.slice(-4)}`

    return cardObj
  }

  /**
   * Gets a specific card from a card array based on its cardIds.
   * @param {Object} cardIds - An object of cardIds and their associated provider.
   * @param {Array} cards - An array of card objects.
   * @return {Object} Returns the card if it is found.
   */
  static getCardFromCards (cardIds, cards) {
    try {
      if (Array.isArray(cards) === false) {
        throw new Error('Cards should be an array')
      }

      return cards.find(card => CreditCardUtil.isSameCard(cardIds, card.cardIds))
    } catch (error) {
      Logger.error('Error on getCardFromCards')
      Logger.debug(error)
      throw error
    }
  }

  /**
   * Compares two sets of card IDs to see if they are the same.
   * @param {Array} aCardIds - An array of cardId objects and their associated provider.
   * @param {Array} bCardIds - An array of cardId objects and their associated provider.
   * @return {Boolean} Returns true if the cards are the same, and false if not.
   */
  static isSameCard (aCardIds, bCardIds) {
    try {
      if (isEmpty(aCardIds) || isEmpty(bCardIds) || aCardIds.length !== bCardIds.length) {
        return false
      }

      for (let i = 0; i < aCardIds.length; i++) { // Loop through each type of id on first card
        const aCardId = aCardIds[i]
        const matchingIds = bCardIds.filter(id => id.type === aCardId.type) // Find matching id type on second card
        if (isEmpty(matchingIds) === true) {
          return false // No matching type found on the second card
        }

        const bCardId = matchingIds[0]
        if (aCardId.id !== bCardId.id) {
          return false // Matching type does not have matching id
        }
      }
      return true
    } catch (error) {
      Logger.error('Error on isSameCard')
      Logger.debug(error)
      throw error
    }
  }
}

export default CreditCardUtil
